import { useQuery } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export const permissionKeys = {
  all: ['permissions'],
  lists: () => [...permissionKeys.all, 'list'],
  list: (filters) => [...permissionKeys.lists(), filters],
};

export function usePermissions(filters = {}) {
  return useQuery({
    queryKey: permissionKeys.list(filters),
    queryFn: async () => {
      const data = await apiHelper.getResource('/rbac/permissions/');
      return data;
    },
  });
}